import { TWhiteLabel } from '../white-label.model';
import { WHITE_LABEL_COLOR_KEYS } from './has-custom-colors';

const WHITE_LABEL_EDITABLE_KEYS: (keyof TWhiteLabel)[] = [
  ...WHITE_LABEL_COLOR_KEYS,
  'fontFamily',
  'logoDark',
  'logoLight',
];

export function hasWhiteLabelChanges(
  whiteLabel: TWhiteLabel,
  storedWhiteLabel: TWhiteLabel,
): boolean {
  return WHITE_LABEL_EDITABLE_KEYS.some(
    (key) => (whiteLabel[key] ?? '') !== (storedWhiteLabel[key] ?? ''),
  );
}
